<template>
    <!--  編輯名片樣式的組件  -->
    <div v-if="null != currEditCardId" class="unvisible-savecard-iframe">
        <cardEditorIframe :id="currEditCardId" :tag="'saveCard'" @save-success="saveCardCallback" />
    </div>
</template>

<script setup>
    import cardApi from "@/request/api";
    import {ref, toRef, onMounted} from "vue";
    import {useUserinfo} from "@/stores/userinfo";
    import cardEditorIframe from "@/components/shopopee/card/cardEditorIframe"

    const props = defineProps(["companyObj"])
    const emits = defineEmits(["save-success"])

    const userInfoRef = toRef(useUserinfo())

    const currEditCardId = ref(null)

    function updateCompanyCardList() {
        const request = cardApi.queryCompanyDefaultMemberWork
        const params = request.getParams()

        if (null != props.companyObj){
            params.companycode = props.companyObj.companycode
        }else{
            params.companycode = userInfoRef.value.companycode
        }


        request.send(params, (res) => {
            if (res.code == 200){
                currEditCardId.value = res.detail.id
            }
        })
    }

    function saveCardCallback(){
        emits("save-success")

    }

    onMounted(() => {
        updateCompanyCardList()
    })
</script>

<style scoped>
    .unvisible-savecard-iframe {
        position: absolute;
        left: 0;
        top: 200vh;
        width: 900px;
        height: 900px;
        z-index: 9999;
    }
</style>